import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthGuard } from './auth.guard';
import { WaitForUserGuard } from './wait-for-user-guard.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInAndUsersLoadedGuard {
  constructor(private authGuard: AuthGuard, private waitForUserGuard: WaitForUserGuard) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authGuard.canActivate(route, state).pipe(
      mergeMap(loggedIn => {
        if (loggedIn) {
          return this.waitForUserGuard.canActivate();
        } else {
          return of(false);
        }
      }),
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
